<template>
<v-container fluid class="pa-0">
<!-- Formulaire -->
    <v-card class="ma-2 pa-5 elevation-2" style="overflow-x: hidden;">
        <v-card-text>
        <v-row>
            <v-col cols="12" md="6">
                <v-text-field label="Nom" prepend-icon="mdi-card-account-details-outline" v-model="item.ctt_lastname"></v-text-field>
                <v-text-field label="Tel" prepend-icon="mdi-phone" v-model="item.ctt_phone"></v-text-field>
                <v-text-field label="Nom complet / Autre" prepend-icon="mdi-account-box-outline" v-model="item.ctt_middlename"></v-text-field>
                <v-select item-text="sta_label" item-value="sta_id"
                    :items="stateListByGroup['GEN']" v-model="item.ctt_sta_id" label="Statut" single-line
                    prepend-icon="mdi-format-list-bulleted-type">
                </v-select>
            </v-col>
            <v-col cols="12" md="6">
                <v-text-field label="Prénom" prepend-icon="mdi-account-outline" v-model="item.ctt_firstname"></v-text-field>
                <v-text-field label="Mobile" prepend-icon="mdi-cellphone" v-model="item.ctt_mobile"></v-text-field>
                <v-text-field label="Courriel" prepend-icon="mdi-email-outline" v-model="item.ctt_email"></v-text-field>
                <v-select item-text="typ_name" item-value="typ_id"
                    :items="typeListByGroup['CTT']" v-model="item.ctt_typ_id" label="Type" single-line
                    prepend-icon="mdi-format-list-bulleted-type">
                </v-select>
            </v-col>
        </v-row>
        <v-expansion-panels>
            <v-expansion-panel>
                <v-expansion-panel-header>Société</v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-row>
                        <v-col cols="12" md="12">
                            <v-text-field label="Dénomination sociale" prepend-icon="mdi-domain" v-model="item.ctt_company_name"></v-text-field>
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
                <v-expansion-panel-header>Adresse</v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-row>
                        <v-col cols="12" md="4">
                            <v-text-field label="Addresse 1" prepend-icon="mdi-map-marker-outline" v-model="item.ctt_customfields['ctt_add_adr1']"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field label="Addresse 2" v-model="item.ctt_customfields['ctt_add_adr2']"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field label="Addresse 3" v-model="item.ctt_customfields['ctt_add_adr3']"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field label="Code postale" prepend-icon="mdi-map-marker-radius" v-model="item.ctt_customfields['ctt_add_zip']"></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field label="Ville" v-model="item.ctt_customfields['ctt_add_town']"></v-text-field>
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        </v-card-text>
    </v-card>
    <div class="text-right mt-3 mr-3">
        <v-btn rounded class="mr-2" color="success" :loading="saveProgress" @click.native="saveForm()" :disabled="saveProgress">
            <v-icon left dark>mdi-content-save-outline</v-icon>Enregistrer
        </v-btn>
        <v-btn rounded text color="grey" :to="'/contacts/'">
            <v-icon left dark>mdi-close</v-icon>Retour
        </v-btn>
    </div>
</v-container>
</template>

<script>
import { mapState, mapActions, mapWritableState } from 'pinia'
import { useTypeStore } from '@/stores/type'
import { useStateStore } from '@/stores/state'
import { useContactStore } from '@/stores/contact'

export default {
    name: 'contact-edit',
    props: [],
    data: function () {
        return {
            search: '',
            footer: { 'items-per-page-all-text':"tout", 'items-per-page-text':'Ligne par page' },
            pagination: { totalItems: 0, rowsPerPage: 5, rowsPerItem: [5,15,25,35,{text:'Tout',value:-1}] },
            saveProgress: false,         // Enregistrement en cours...
        }
    },
    computed: {
        ...mapState(useTypeStore, {typeListByGroup: 'itemListByGroup', typeListById: 'itemListById' }),
        ...mapState(useStateStore, {stateListByGroup: 'itemListByGroup', stateListById: 'itemListById' }),
        ...mapWritableState(useContactStore, {item: 'item' }),
    },
    mounted:function (){
        if( parseInt( this.$route.params.ctt_id ) > 0 && this.$route.params.ctt_id !== undefined ){
            this.fetchItem(this.$route.params.ctt_id)
        }
    },
    methods: {
        ...mapActions(useContactStore, ['fetchItem', 'fetchItems', 'storeItem', 'updateItem', 'destroyItem', 'RESET_ITEM']),
        async saveForm () {
            // Enregistrement du formulaire
            this.saveProgress = true
            if( this.item.ctt_id > 0 ){
                this.item.ctt_middlename = ( !this.item.ctt_middlename.length ) ? this.item.ctt_firstname + ' ' + this.item.ctt_lastname : this.item.ctt_middlename
                this.updateItem().then( () => {
                    this.$root.$toast({ color: 'success', text: 'Fiche enregistrée !' })
                }).catch( (error) => {
                    this.$root.$toast({ text: 'Erreur lors de l\'enregistrement !', error: error })
                });
                this.fetchItems()
                this.$router.push({ path: '/contacts' })
            } else {
                this.item.ctt_middlename = this.item.ctt_firstname + ' ' + this.item.ctt_lastname
                this.storeItem().then( () => {
                    this.$root.$toast({ color: 'success', text: 'Fiche enregistrée !' })
                    this.$router.push({ path: '/contacts' })
                }).catch( (error) => {
                    this.$root.$toast({ text: 'Erreur lors de l\'enregistrement !', error: error })
                    this.saveProgress = false
                });
            }
        },
    },
    components: { }
}
</script>